/* @flow */
import * as React from 'react';

import { defaultTheme } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';

import { type Customer, ageGroup, gender } from '../rules/types';
import FA01 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f01_ic@3x.png';
import FA02 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f02_ic@3x.png';
import FA03 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-f03_ic@3x.png';
import FC01 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f01_ic@3x.png';
import FC02 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f02_ic@3x.png';
import FC03 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-f03_ic@3x.png';
import FE01 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f01_ic@3x.png';
import FE02 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f02_ic@3x.png';
import FE03 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_el-f03_ic@3x.png';
import MA01 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m01_ic@3x.png';
import MA02 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m02_ic@3x.png';
import MA03 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_30s-m03_ic@3x.png';
import MC01 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m01_ic@3x.png';
import MC02 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m02_ic@3x.png';
import MC03 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_ch-m03_ic@3x.png';
import ME01 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m01_ic@3x.png';
import ME02 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m02_ic@3x.png';
import ME03 from '../../assets/images/pages/sushi/customer/sushi_ﬁ_el-m03_ic@3x.png';

type Props = { customer: Customer };

export function CustomerIcon(props: Props) {
  const { customer, ...rest } = props;
  return <Icon {...rest} src={icons[customer.gender][customer.ageGroup][customer.kind]} alt="customer icon" />;
}

const icons = {
  [gender.MALE]: {
    [ageGroup.CHILD]: { '1': MC01, '2': MC02, '3': MC03 },
    [ageGroup.ADULT]: { '1': MA01, '2': MA02, '3': MA03 },
    [ageGroup.MIDDLE_AGE]: { '1': ME01, '2': ME02, '3': ME03 },
  },
  [gender.FEMALE]: {
    [ageGroup.CHILD]: { '1': FC01, '2': FC02, '3': FC03 },
    [ageGroup.ADULT]: { '1': FA01, '2': FA02, '3': FA03 },
    [ageGroup.MIDDLE_AGE]: { '1': FE01, '2': FE02, '3': FE03 },
  },
};

const Icon = styled('img')(
  css({
    size: ['24px', '24px', '42px'],
  })
);
Icon.defaultProps = { theme: defaultTheme };
